import React, { useState } from 'react';
import { X } from 'lucide-react';
import AlertModal from './AlertModal';
import { useAlert } from '../hooks/UseAlert';

const ContactFormModal = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    otherSubject: ''
  });

  const { alertConfig, closeAlert, success, warning, error } = useAlert();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const finalSubject =
      formData.subject === 'Autre'
        ? formData.otherSubject
        : formData.subject;

    try {
      const response = await fetch('/api/send-contact-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: finalSubject,
          message: formData.message
        })
      });

      const data = await response.json();

      if (data.success) {
        success('Message envoyé avec succès');
        onClose();
      } else {
        throw new Error(data.error);
      }
    } catch (error) {
      console.error(error);
      error('Erreur lors de l’envoi du message');
    }
  };

  return (
    <>
      <AlertModal
        isOpen={alertConfig.isOpen}
        onClose={closeAlert}
        type={alertConfig.type}
        title={alertConfig.title}
        message={alertConfig.message}
        confirmText={alertConfig.confirmText}
        onConfirm={alertConfig.onConfirm}
        showCancel={alertConfig.showCancel}
        cancelText={alertConfig.cancelText}
      />
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg w-full max-w-lg p-6 relative">
          <button
            onClick={onClose}
            className="absolute top-3 right-3 text-black hover:text-gray-700"
          >
            <X />
          </button>

          <h2 className="text-xl font-semibold text-purple-900 mb-4">
            Formulaire de contact
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4 text-black">
            <input
              type="text"
              name="name"
              placeholder="Votre nom"
              required
              className="w-full border rounded p-2 bg-white text-black placeholder:text-black/60"
              onChange={handleChange}
            />

            <input
              type="email"
              name="email"
              placeholder="Votre email"
              required
              className="w-full border rounded p-2 bg-white text-black placeholder:text-black/60"
              onChange={handleChange}
            />

            <select
              name="subject"
              required
              className="w-full border rounded p-2 bg-white text-black"
              onChange={handleChange}
            >
              <option value="" className="text-black" disabled>
                Motif de la demande
              </option>
              <option value="Renseignement" className="text-black">
                Renseignement
              </option>
              <option value="Disponibilité" className="text-black">
                Disponibilité
              </option>
              <option value="Carte cadeau" className="text-black">
                Carte cadeau
              </option>
              <option value="Remboursement" className="text-black">
                Demande de remboursement
              </option>
              <option value="Annulation" className="text-black">
                Annulation
              </option>
              <option value="Autre" className="text-black">
                Autre
              </option>
            </select>

            {formData.subject === 'Autre' && (
              <input
                type="text"
                name="otherSubject"
                placeholder="Précisez le motif"
                required
                className="w-full border rounded p-2 bg-white text-black placeholder:text-black/60"
                onChange={handleChange}
              />
            )}

            <textarea
              name="message"
              placeholder="Votre message"
              rows="4"
              required
              className="w-full border rounded p-2 bg-white text-black placeholder:text-black/60"
              onChange={handleChange}
            />

            <button
              type="submit"
              className="w-full bg-purple-600 text-white py-2 rounded hover:bg-purple-700 transition"
            >
              Envoyer le message
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ContactFormModal;
